import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit } from '@angular/core';

import { Category, FinnairBoundItem, FinnairPassengerItem } from '@fcom/dapi/api/models';
import { FinnairServiceItemWithUpsell } from '@fcom/dapi/interfaces';

import { getSummaryForCategory } from '../../../../utils/services-summary.utils';

interface ServiceSummary {
  quantity?: number;
  description: string;
  text?: string;
}

@Component({
  selector: 'fin-included-product-item-summary',
  templateUrl: './included-product-item-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IncludedProductItemSummaryComponent implements OnInit, OnChanges {
  @Input() passengers: FinnairPassengerItem[];
  @Input() bound: FinnairBoundItem;
  @Input() service: FinnairServiceItemWithUpsell;
  @Input() isShortHaulFlight: boolean;
  @Input() bodyClass = 'font-body-2';
  protected readonly Category = Category;
  protected serviceSummary: ServiceSummary[] = [];

  ngOnChanges(): void {
    this.update();
  }

  ngOnInit(): void {
    this.update();
  }

  private update() {
    this.serviceSummary = getSummaryForCategory(
      this.service?.category,
      this.bound,
      this.service,
      this.isShortHaulFlight
    );
  }
}
